module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABNklEQVQ4T5WTzVWDUBCF74VzsqYDKQFJAYEO0oG6kWSXDiQVqCvCSkvQCsQCQDqQEpJlFmE87wU4ovzlbTjnzcw3990ZiJ7jvIiFIxYmYZ1meM/vuO9KZdelKjaO+CJhq7gA+5Lw83vmf/M7Ae5OnkAsyxkc1Xm+kzchrCyg1wlwY0koqtH5COGoLwW6owC2ViNIfgPSFX2tQAH6vBi6V4qaJziR2DRxNQUkwKH2owG4sYQEHiYBBM/Zihv9zLrAjWVD4HESANhmAcMWwInEMw18VKZ9ViA1xgLKRGgDb6r4KGBbAdTYVKFXlgjrBqcSfr6mNr5lomngu+5wMUAVzGPRuyDAsALi+t8ULgGkARvlrVV2YymI8V0YAiQEFiOjPKQBrTqnrSCSWxjnP7D3lCiyNV/r+A9vbYcRy9gN3wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sc.png
// module id = k8bu
// module chunks = 1